import environment from "./BaseEnvironment";

/*
 * environments for production
 * You shouldn't have override anything.
 */

const baseUrl = "https://calingo.claims.upquai.com";      // URL to run the application (HOST & PORT)
const baseApi = "https://calingo.claims.webservice.upquai.com/api"; // URL of production server
const APP_ENVIRONMENT = "production"
const enableItemClassification = false; 



const env = environment(baseApi);

const ProductionEnvironment = {
  ...env,
  baseUrl: baseUrl,
  baseApi: baseApi,
  APP_ENVIRONMENT : APP_ENVIRONMENT,
  enableItemClassification: enableItemClassification

};

export default ProductionEnvironment;
